import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import {
  useAddCoordinatorMutation,
  useRemoveCoordinatorMutation,
  useCoordinatorsQuery,
} from "../Teams.state";
import { CardBody } from "../../App.styles";
import TeamOnlySelect from "../TeamOnlySelect";
import TeamSelect from "../TeamSelect";
import Spinner from "../../common/Spinner";

const Coordinators = () => {
  const { t } = useTranslation();
  const { data: coordinators, isFetching } = useCoordinatorsQuery();
  const { addCoordinator } = useAddCoordinatorMutation();
  const { removeCoordinator } = useRemoveCoordinatorMutation();

  const handleTeamCoordinatorChange = useCallback(
    async (selectedTeam) => {
      if (!selectedTeam) {
        return;
      }

      const players = selectedTeam.users || [];
      const allPlayersCoordinators = players.every((player) =>
        coordinators?.some((coordinatorPlayer) => coordinatorPlayer.id === player.id)
      );

      if (allPlayersCoordinators) {
        for (let player of players) {
          if (coordinators?.some((coordinatorPlayer) => coordinatorPlayer.id === player.id)) {
            await removeCoordinator(player);
          }
        }
        return;
      }

      for (let player of players) {
        if (!coordinators?.some((coordinatorPlayer) => coordinatorPlayer.id === player.id)) {
          await addCoordinator(player);
        }
      }
    },
    [addCoordinator, coordinators, removeCoordinator]
  );

  const handleCoordinatorsChange = useCallback(
    async (value) => {
      for (let player of (coordinators || []).filter(
        (coordinatorPlayer) => !(value || []).find((v) => v.id === coordinatorPlayer.id)
      )) {
        await removeCoordinator(player);
      }
    },
    [coordinators, removeCoordinator]
  );

  return (
    <CardBody className="card">
      <div className="card-header bg-dark text-light">
        <span className="card-title">{t("Coordinators")}</span>
      </div>
      <div className="card-body">
        <p
          dangerouslySetInnerHTML={{
            __html: t(
              "Want someone else to coordinate the event? Add them here to give them light weight administrative access."
            ),
          }}
        />
        {isFetching && coordinators === undefined ? (
          <Spinner size="0.875rem" />
        ) : (
          <>
            <TeamOnlySelect
              setValue={handleTeamCoordinatorChange}
              mapLabel="name"
              placeholder={t("Select team...")}
              disableClearable={true}
              loading={isFetching}
            />
            <div className="mt-2">
              <TeamSelect
                setValue={handleCoordinatorsChange}
                value={coordinators}
                mapLabel="email"
                placeholder={t("Select people...")}
                loading={isFetching}
                readOnly
              />
            </div>
          </>
        )}
      </div>
    </CardBody>
  );
};

export default Coordinators;
